import React, { useEffect, useState } from 'react';
import { Card, CardContent } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import styles from './SiteView.module.scss';
import SiteViewChart from './chart/SiteViewChart';
import ImgGrayPieChart from '../../../assets/icons/ImgGrayPieChart.svg';
import {
	getLeadsNumberBySalesAgentId,
	getLeadsTotalNumber,
} from '../../../api/Dashboard/getLeads.api';
import moment from 'moment';
import { connect } from 'react-redux';
const SiteView = (props) => {
	const { salesAgentId, filterByDate, purchasers } = props;
	const [apsStatusArr, setApsStatusArr] = useState([]);
	const [totalNum, setTotalNum] = useState(0);
	const [leadsNum, setLeadsNum] = useState(0);
	useEffect(() => {
		if (salesAgentId && salesAgentId !== 'allSalesAgents') {
			console.log('');
			let purchasersFiltered =
				purchasers?.length > 0 &&
				purchasers
					.filter(
						(purchaser) =>
							purchaser?.leadToSalesAgent === salesAgentId
					)
					.filter((purchaser) => {
						if (purchaser?.createTimestamp) {
							let timestamp = moment(
								purchaser.createTimestamp
							).valueOf();
							if (filterByDate === 'All') {
								return true;
							} else if (filterByDate === 'Month') {
								return moment(timestamp).isBetween(
									moment().subtract(1, 'months'),
									moment()
								);
							} else if (filterByDate === 'Week') {
								return moment(timestamp).isBetween(
									moment().subtract(7, 'days'),
									moment()
								);
							} else if (filterByDate === 'Today') {
								return moment(timestamp).isBetween(
									moment().startOf('day'),
									moment()
								);
							} else {
								return true;
							}
						} else {
							return true;
						}
					});

			let numOfpurchasers = Object?.keys(purchasersFiltered).length;

			setApsStatusArr(numOfpurchasers);
		} else if (salesAgentId === 'allSalesAgents') {
			let purchasersFiltered =
				purchasers?.length > 0 &&
				purchasers.filter((purchaser) => {
					if (purchaser?.createTimestamp) {
						let timestamp = moment(
							purchaser.createTimestamp
						).valueOf();
						if (filterByDate === 'All') {
							return true;
						} else if (filterByDate === 'Month') {
							return moment(timestamp).isBetween(
								moment().subtract(1, 'months'),
								moment()
							);
						} else if (filterByDate === 'Week') {
							return moment(timestamp).isBetween(
								moment().subtract(7, 'days'),
								moment()
							);
						} else if (filterByDate === 'Today') {
							return moment(timestamp).isBetween(
								moment().startOf('day'),
								moment()
							);
						} else {
							return true;
						}
					} else {
						return true;
					}
				});
			let numOfpurchasers = Object?.keys(purchasersFiltered).length;
			setApsStatusArr(numOfpurchasers);
		}
	}, [salesAgentId, filterByDate, purchasers]);

	useEffect(() => {
		if (apsStatusArr !== 0 && leadsNum !== 0) {
			setTotalNum(
				((apsStatusArr / (leadsNum + apsStatusArr)) * 100).toFixed(0)
			);
		} else {
			setTotalNum(0);
		}
	}, [leadsNum, apsStatusArr]);
	useEffect(() => {
		if (salesAgentId && salesAgentId !== 'allSalesAgents') {
			getLeadsNumberBySalesAgentId(
				salesAgentId,
				filterByDate,
				(returned) => {
					setLeadsNum(returned);
				}
			);
		} else if (salesAgentId === 'allSalesAgents') {
			getLeadsTotalNumber(filterByDate, (returned) => {
				setLeadsNum(returned);
			});
		}
	}, [salesAgentId, filterByDate]);
	return (
		<>
			<Card className={styles.site_view_card_group} variant='outlined'>
				<CardContent>
					<h3>Lead Conversions</h3>
					{apsStatusArr === 0 ? (
						<div className={styles.img_wrapper}>
							<img
								className={styles.chartImg}
								src={ImgGrayPieChart}
								alt='no data status'
							/>
							<div className={styles.img_label}>
								<FiberManualRecordIcon />
								<span>No Leads</span>
							</div>
						</div>
					) : (
						<>
							<div className={styles.card_text_content}>
								{totalNum}%
							</div>
							<SiteViewChart
								apsStatusArr={apsStatusArr}
								leadsNum={leadsNum}
							/>
						</>
					)}
				</CardContent>
			</Card>
		</>
	);
};
const mapStateToProps = (state) => ({
	purchasers: state.purchasers.purchaserList,
});
export default connect(mapStateToProps)(SiteView);
